<template>
  <div class="container-detalle-trabajo">
    <loading :active.sync="loader" :can-cancel="false" :is-full-page="true"></loading>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="4" class="text-left" v-if="escaner.descargaOdt">
              <span class="textForm">ODT generada por el escáner<span style="color: red">*</span></span>
              <input type="file" ref="inputArchivoODT" multiple @change="changeArchivoODT($event)" style="display: none;">
              <div class="d-flex">
                <b-form-input
                    placeholder="Examinar..."
                    class="form-control-sm"
                    @click.stop="abrirSelectorArchivos"
                />
                <b-button size="sm" variant="secondary" class="rounded-pill ml-2" @click.stop="abrirSelectorArchivos">Examinar</b-button>
              </div>
            </b-col>

            <b-col :cols="escaner.descargaOdt ? 3 : 4" :offset="escaner.descargaOdt ? 1 : 0" class="text-left" v-if="escaner.descargaArchivos">
              <span class="textForm">Archivos adicionales</span>
              <br>
              <input type="file" ref="inputArchivosAdicionales" multiple @change="changeArchivosAdicionales($event)" style="display: none;">
              <b-button variant="outline-primary" class="rounded-pill" size="sm" @click="$refs.inputArchivosAdicionales.click()">
                Agregar archivos
              </b-button>

              <em class= "trash_svg btn-agregar-archivos-ad"
                   v-b-tooltip.hover.topright.v-light
                   title="Eliminar todos los archivos adicionales"
                  v-if="form.listaArchivosGuardar.some(f => !f.generadoEscaner)"
                  @click="eliminarArchivosAdicionales()"
              ></em>
            </b-col>

            <b-col :cols="(escaner.descargaOdt && escaner.descargaArchivos) ? 4 : 8" class="text-left" v-if="form.listaArchivosGuardar.length > 0">
              <span class="textForm">Archivos cargados</span>
              <br>
              <div class="archivos-container">
                <div class="archivo-miniatura" v-for="(item, index) of form.listaArchivosGuardar" :key="index">
                  <div class="logo-archivo">
                    <img src="../../../assets/laboratorio/pdf.svg" alt="logo-pdf-archivo">
                    <em v-if="!item.progreso" class="close_outline_svg" style="width: 14px; cursor: pointer; position: absolute; right: 7px;"
                        v-b-tooltip.hover.topleft.v-light
                        title="Eliminar"
                        @click="eliminarArchivo(index)"
                    ></em>

                    <!-- Mostrar spinner mientras se sube -->
                    <b-spinner small
                        v-else-if="item.progreso > 0 && item.progreso < 100"
                        style=" width: 14px; position: absolute; right: 7px;"
                    ></b-spinner>

                    <!-- Mostrar ícono de éxito si ya se subió -->
                    <em
                        v-else-if="item.progreso === 100"
                        class="check_green_svg"
                        style="width: 14px; position: absolute; right: 7px;"
                        v-b-tooltip.hover.topleft.v-light
                        title="Archivo subido con éxito"
                    ></em>

                  </div>
                  <div class="archivo-name">
                    <span style="font-size: xx-small">{{ item.nombreArchivo }}</span>
                  </div>
                </div>
              </div>
            </b-col>

          </b-row>
          <b-row>
            <b-col cols="6" class="text-left" v-if="escaner.generaFolio">
              <span class="textForm">Folio de referencia<span style="color: red">*</span></span>
              <b-form-input
                  class="form-control form-control-sm"
                  placeholder="Ingresa el folio de referencia"
                  v-model="form.folioReferencia"
                  type="text"
                  :state="form.folioReferencia != null && form.folioReferencia !== '' "
                  required
              ></b-form-input>
            </b-col>

            <b-col cols="6" class="text-left">
              <span class="textForm">Observaciones <span style="color: red">*</span></span>
              <b-form-textarea
                  style="resize:both;"
                  class="form-control form-control-sm"
                  placeholder="Ingresa las observaciones"
                  v-model="form.observaciones"
                  :state="form.observaciones != null && form.observaciones !== '' "
                  type="text"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" class="text-left">
              <span class="textForm">Colorímetro<span style="color: red">*</span></span>
              <v-select
                  v-model="form.idColorimetro"
                  style="width: 100%;"
                  placeholder="Selecciona un colorimetro"
                  id="idColorimetro"
                  label="nombre"
                  required
                  :options="listaColorimetrosProps"
                  :reduce="(variable) => variable.idColorimetro"
                  :clearable="false"
                  @input="filtrarColores(form.idColorimetro)"
              ><span slot="no-options">No hay valores configurados disponibles</span>
              </v-select>
            </b-col>
            <b-col cols="6" class="text-left">
              <span class="textForm">Tono final<span style="color: red">*</span></span>
              <v-select
                  v-model="form.tono"
                  style="width: 100%;"
                  placeholder="Selecciona un color"
                  required
                  label="nombre"
                  :options="listaColores"
                  :reduce="(variable) => variable.nombre"
                  :clearable="false"
              />
            </b-col>
          </b-row>


            <div class="text-center mt-4">
              <b-button style="background: #1B81AF" variant="primary" pill size="sm" @click="finalizarOdt()"
                        :disabled="(escaner.descargaOdt && form.listaArchivosGuardar.length === 0) ||
                        (escaner.descargaArchivos && form.listaArchivosGuardar.length === 0) ||
                        (escaner.generaFolio && form.folioReferencia == null) ||
                        form.observaciones == null || loader || form.idColorimetro == null || form.tono == null">
                <span>Finalizar</span>
                <b-spinner v-if="loader" variant="light" label="spinner" small></b-spinner>
              </b-button>
            </div>

        </b-col>
      </b-row>
  </div>
</template>

<script>
import {Upload} from "@aws-sdk/lib-storage";
import {AwsService} from "@/apiServices/aws/AwsService";
import {S3Client} from "@aws-sdk/client-s3";
import moment from "moment/moment";

export default {
  name: "FlujoDigital",
  props: {
    escaner: Object,
    ruta: String,
    idPaciente: Number,
    loader: Boolean,
    listaColorimetrosProps: Array,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      token: null,
      hoy : this.$moment().format("DD-MM-YYYY"),
      awsServicio: new AwsService(),
      form: {
        folioReferencia: null,
        observaciones: null,
        listaArchivosGuardar: [],
        idColorimetro: null,
        tono: null,
      },
      listaColores: [],
    }
  },
  async created() {
    this.token = this.$localStorageService.getTokenAWS();
    await this.validarTokenAWS();
  },
  methods: {
    abrirSelectorArchivos() {
      this.$nextTick(() => {
        if (this.$refs.inputArchivoODT) {
          this.$refs.inputArchivoODT.click();
        } else {
          console.error("El elemento inputArchivoODT no existe en $refs");
        }
      });
    },

    async changeArchivosAdicionales(e) {
      const MAX_ARCHIVOS = 5; // Define tu límite máximo
      const files = e.target.files || e.dataTransfer.files;

      // Validación estricta
      if (this.form.listaArchivosGuardar.length >= MAX_ARCHIVOS || this.form.listaArchivosGuardar.length === MAX_ARCHIVOS) {
        this.mostrarErrorLimite();
        e.target.value = '';
        return;
      }

      if (this.form.listaArchivosGuardar.length + files.length > MAX_ARCHIVOS) {
        this.mostrarErrorLimite(`Estás intentando subir ${files.length} archivos, pero solo puedes subir ${MAX_ARCHIVOS - this.form.listaArchivosGuardar.length} más`);
        e.target.value = '';
        return;
      }


      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const extension = file.name.split('.').pop().toLowerCase();
        const timestamp = this.$moment().format("YYYYMMDDHHmmssSSS");
        const nombreBase = 'ARCHIVO_AD' + " " + timestamp; // Elimina la extensión

        this.form.listaArchivosGuardar.push({
          file: file,
          nombreArchivo: `${this.idPaciente}_${nombreBase}${i}.${extension}`,
          extension: extension,
          generadoEscaner: false,
        });
      }
      e.target.value = '';
    },
    async changeArchivoODT(e) {
      const MAX_ARCHIVOS = 5; // Define tu límite máximo
      const files = e.target.files || e.dataTransfer.files;

      // Validación estricta
      if (this.form.listaArchivosGuardar.length >= MAX_ARCHIVOS || this.form.listaArchivosGuardar.length === MAX_ARCHIVOS) {
        this.mostrarErrorLimite();
        e.target.value = '';
        return;
      }

      if (this.form.listaArchivosGuardar.length + files.length > MAX_ARCHIVOS) {
        this.mostrarErrorLimite(`Estás intentando subir ${files.length} archivos, pero solo puedes subir ${MAX_ARCHIVOS - this.form.listaArchivosGuardar.length} más`);
        e.target.value = '';
        return;
      }

      files.forEach((file, i) => {
        const extension = file.name.split('.').pop().toLowerCase();
        const timestamp = this.$moment().format("YYYYMMDDHHmmssSSS");
        const nombreBase = "ARCHIVO_ODT" + " " + timestamp; // Elimina la extensión

        this.form.listaArchivosGuardar.push({
          file: file,
          nombreArchivo: `${this.idPaciente}_${nombreBase}${i}.${extension}`,
          extension: extension,
          generadoEscaner: true,
        });
      });
      e.target.value = '';
    },

    mostrarErrorLimite(mensajePersonalizado = null) {
      const mensaje = mensajePersonalizado || 'Ya has alcanzado el límite máximo de 5 archivos';

      this.$swal({
        icon: 'error',
        title: 'Límite de archivos',
        text: mensaje,
        confirmButtonText: 'Entendido'
      });
    },

    eliminarArchivo(index) {
      this.$swal({
        title: '¿Eliminar archivo?',
        text: `Estás por eliminar "${this.form.listaArchivosGuardar[index].nombreArchivo}"`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Elimina el archivo del array
          this.form.listaArchivosGuardar.splice(index, 1);

          this.$swal({
            title: 'Eliminado',
            text: 'El archivo ha sido removido',
            icon: 'success',
            timer: 1500
          });
        }
      });
    },


    eliminarArchivosAdicionales() {
      // Filtrar primero los archivos adicionales
      const archivosAdicionales = this.form.listaArchivosGuardar.filter(
          file => !file.generadoEscaner
      );

      // Si no hay archivos adicionales
      if (archivosAdicionales.length === 0) {
        this.$swal({
          title: 'No hay archivos para eliminar',
          text: 'No se encontraron archivos adicionales',
          icon: 'info',
          timer: 1500
        });
        return;
      }

      // Confirmación
      this.$swal({
        title: '¿Eliminar todos los archivos adicionales?',
        html: `Estás por eliminar <b>${archivosAdicionales.length} archivo(s)</b>:<br>
           <ul class="text-left mt-2">
             ${archivosAdicionales.map(f => `<li>${f.nombreArchivo}</li>`).join('')}
           </ul>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar todos',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          // Eliminar todos los adicionales
          this.form.listaArchivosGuardar = this.form.listaArchivosGuardar.filter(
              file => file.generadoEscaner
          );
          return true;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: 'Eliminados',
            html: `Se eliminaron ${archivosAdicionales.length} archivo(s) adicionales`,
            icon: 'success',
            timer: 3000
          });
        }
      });
    },

    async guardarArchivos() {
      await this.validarTokenAWS();

      if (this.form.idColorimetro === null || this.form.tono === null) {
        this.$swal({
          title: 'Falta llenar el campo(s) Colorimetro / Tono',
          icon: 'warning',
          timer: 2500
        });
        return;
      }

      if (this.form.listaArchivosGuardar.length === 0) {
        this.$swal({
          title: 'No hay archivos para guardar',
          icon: 'warning',
          timer: 2500
        });
        return;
      }

      this.loaderArchivo = true;

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      let ruta = this.ruta.replace("#id_paciente", this.idPaciente.toString());
      let nombreCarpeta = `ODT ${this.hoy}`;

      try {
        for (const [index, archivo] of this.form.listaArchivosGuardar.entries()) {
          try {
            let tipoCarpeta = !archivo.generadoEscaner
                ? "ARCHIVOS ADICIONALES"
                : "GENERADO ESCANER";

            let rutaDirectorio = `${ruta}/${nombreCarpeta}/${tipoCarpeta}`;
            let filePath = `${rutaDirectorio}/${archivo.nombreArchivo}`;

            this.form.listaArchivosGuardar[index].urlRuta = filePath;

            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
            };

            const upload = new Upload({
              client: client,
              params: input,
              partSize: 5 * 1024 * 1024,
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.form.listaArchivosGuardar[index], "progreso", porcentaje);
            });

            await upload.done();

          } catch (error) {
            console.error(`Error al subir el archivo ${archivo.nombreArchivo}:`, error);
            throw error;
          }
        }

        this.$emit('finalizar', this.form);

      } catch (error) {
        console.error("Error en el proceso:", error);

        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `Hubo un problema: ${error.message}`,
        });
      } finally {
        this.loaderArchivo = false; // esto sí puedes mantener si quieres desactivar el loader
      }
    },

    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },

    async finalizarOdt() {
      // 1. Validar si se requiere archivo del escáner
      if (this.escaner.descargaOdt && !this.form.listaArchivosGuardar.some(f => f.generadoEscaner)) {
        this.$swal({
          icon: "error",
          text: "El archivo ODT del Escáner es requerido"
        });
        return;
      }

      // 2. Validar si se requieren archivos adicionales
      if (this.escaner.descargaArchivos && !this.form.listaArchivosGuardar.some(f => !f.generadoEscaner)) {
        this.$swal({
          icon: "error",
          text: "Los Archivos Adicionales son requeridos"
        });
        return;
      }

      // 3. Validar folio de referencia
      if (this.escaner.generaFolio && !this.form.folioReferencia) {
        this.$swal({
          icon: "error",
          text: "Ingrese un folio de referencia"
        });
        return;
      }

      // 4. Si no se requiere descarga y el folio está correcto, emitir directamente
      if (
          !this.escaner.descargaOdt &&
          !this.escaner.descargaArchivos &&
          this.escaner.generaFolio &&
          this.form.folioReferencia !== null
      ) {
        this.$emit('finalizar', this.form);
        return;
      }

      // 5. Si no cayó en ninguna de las anteriores, continuar con guardado
      await this.guardarArchivos();
    },

    reset(){
      this.form = {
        folioReferencia: null,
        observaciones: null,
        listaArchivosGuardar: [],
      }
    },

    filtrarColores(idColorimetro){
      this.listaColores = []
      this.listaColorimetrosProps.forEach(c => {
        if (c.idColorimetro === idColorimetro){
          c.coloresId.forEach(color => {
            this.listaColores.push(color)
          })
        }
      })
    },
  },
}
</script>



<style scoped>
.textForm {
  font-size: 10px;
  text-align: left;
}

.btn-agregar-archivos-ad{
  margin-left: 10px;
  cursor: pointer;
  position: absolute;
  scale: 1.3;
  top: 28px;
}

.archivo-miniatura{
  width: 69px;
  min-height: 60px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.archivos-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.archivo-miniatura .logo-archivo{
  display: flex;
  justify-content: center;
}

.archivo-miniatura .archivo-name{
  font-size: xx-small;
  line-height: normal;
}

.container-detalle-trabajo{
  margin: 0 auto;
  display: block;
  max-width: 1200px;
}
</style>
